"use client";

import styled from "styled-components";

export const Container = styled.div<{ $isRelative?: boolean }>`
  margin: 0 auto;
  max-width: 1182px;
  padding: 65px 30px;
  position: relative;
  z-index: 5;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }

  @media (max-width: 480px) {
    padding: 24px 12px;
  }
`;